import type { Except, Merge } from 'type-fest';
import { useField } from '../../../hooks/useField';
import {
    Controlled_SecretInput,
    type Controlled_SecretInputProps,
} from '../../inputs/controlled/Controlled_SecretInput';

export type Form_SecretInputProps<T extends object> = Merge<
    Except<Controlled_SecretInputProps, keyof useField.Result<string>>,
    useField.Props<string, T>
>;

export const Form_SecretInput = <T extends object>({
    name,
    control,
    onChange,
    ...props
}: Form_SecretInputProps<T>) => {
    const fieldProps = useField({
        name,
        control,
        onChange,
    });

    return (
        <Controlled_SecretInput
            {...props}
            {...fieldProps}
        />
    );
};
